/**
 * The major aim of this is to avoid having the developer have this only in their head forcing the next developer to go through 
 * a thorough search on the code before the can figure out eg. types of contentTypes we have.
 * Now all the need to do is come here the the see everything and can also use it from here
 */
const modalTypes = Object.freeze({
    TITLE: 'title',
    MEDIA: 'media',
    ATTACHMENTS: 'attachments',
    DETAILS: 'details',
});
const contentTypes = Object.freeze({
    PROJECT: "Project",
    CREATIVE_WORK: "Creative Work",
    INNOVATION: "Innovation",
    STEM_CREATIONS: "STEM Creations",
});

export { modalTypes, contentTypes }